import React from 'react';
import {bool, number, object,  oneOf, oneOfType, string} from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';

import styles from './IconButton.scss';

const themes = {
  // default is to just omit
  primary: styles.primary,
  secondary: styles.secondary,
  transparent: styles.transparent,
};


class IconButton extends React.PureComponent {
  static propTypes = {
    className: string,
    disabled: bool,
    theme: oneOf(Object.keys(themes)),
    icon: object.isRequired,
    size: oneOfType([string, number]),

  };
  static defaultProps = {
    disabled: false,
    size: undefined,
  };
  render() {
    const {className, icon, size, theme, ...props} = this.props;
    return (
      <button aria-disabled={props.disabled} disabled={props.disabled} type="button" className={classNames(styles.IconButton, themes[theme], className)} {...props}>
        <Icon size={size} icon={icon} />
      </button>
    );
  }
}

export class FauxIconButton extends React.PureComponent {
  static propTypes = {
    className: string,
    icon: object.isRequired,
    size: oneOfType([string, number]),
    theme: oneOf(Object.keys(themes)),
  };
  static defaultProps = {
    size: undefined,
  };
  render() {
    const {className, icon, size, theme, ...props} = this.props;
    return <div className={classNames(styles.IconButton, themes[theme], className)} {...props}>
      <Icon size={size} icon={icon} />
    </div>;
  }
}

export default IconButton;
